import React from 'react'
import { ReferralColDef } from './ReferralColDef.jsx'
import Modal from '../../components/Modal/Modal'
import { FamilyReferralForm } from './FamilyReferralForm.jsx'
import { digmaDate } from "../Tree/Utils"
import { meritalStatus, familyReferralStatus, noYes, noYesOther, 
        oneTill12plus, noYesWasInPastPlural, ReferralMgrDecision, ReferralFamilyDecision } from '../../variables/ComboValues'

export const ModalReferral = (props) => {
   // const buttonStyle = { height: '40px', 'zIndex': '99999' }
    const divStyle = {  backgroundColor: 'rgba(255,255,255,0.95)', height: '700px', color: 'black',
                        top: '95px', right: '160px', display: 'block'  }
    const {referral, addReferralIntoList, removeReferral, newRF, closeModal, mbouser} = props
 
    return(
      <Modal root={document.getElementById('modal-root')}>
        <div className="yahav-modal-referral">
            <button className="close-modal-button" onClick={closeModal}>
                סגור חלון הפניה
            </button>

            <div className="family-form-display modal" style={divStyle} >
                <FamilyReferralForm 
                  data={newRF? emptyReferral : referral} 
                  title={newRF? "הפניה חדשה" : "עדכון הפניה"  }
                  //addReferral={addReferral}
                  addReferralIntoList = {addReferralIntoList }
                  removeReferral={removeReferral} 
                  newRF={newRF} 
                  mbouser = {mbouser}
                    />
            </div>
          </div>
      </Modal>
    )
}

export const getFamilyReferralStatusOptions = () => {
    let i = 0
    for( i=0 ; i < ReferralColDef.length ; i++){
        if (ReferralColDef[i].accessor === "family_referral_status")
            break;
    }
    if (i >= ReferralColDef.length)
        return ("ERR: family_referral_status not found")
    return ReferralColDef[i].options
}

export const FamilyReferralStatusOptions = () => {
    //console.log(ReferralColDef[6]) // family_referral_status
    // console.log(ReferralColDef[6].options) // family_referral_status
    let i = 0
    for( i=0 ; i < ReferralColDef.length ; i++){
        if (ReferralColDef[i].accessor === "family_referral_status")
            break;
    }
    if (i >= ReferralColDef.length)
        return ("ERR: family_referral_status not found")
        
    return (ReferralColDef[i].options.map (val =>
        <option key={val} value={val}>{val}</option>))  
}

export const combineNames = (family, woman, man, status) => {
    status = ""
    if (woman.length > 1){ // woman exists
        if (man.length > 1) // man exists
          return(<div className="family-referral-name">
                  <span className="referral-family">{family}{status}</span> 
                  <span className="referral-woman">{woman}</span> 
                  <span>ו</span>
                  <span className="referral-man">{man}</span></div>)
        else // single woman
            return(<div className="family-referral-name">
                  <span className="referral-family">{family}{status}</span> 
                  <span className="referral-woman">{woman}</span></div>)
    } else if (man.length > 1){ // single man
        return(<div className="family-referral-name">
                  <span className="referral-family">{family}{status}</span> 
                  <span className="referral-man"> {man} </span></div>)
    }
    return(<div className="family-referral-name">
                  <span className="referral-family">{family}</span>{status}</div>) // only family name
}

export var cellData= (product) => [{
    type: "text",
    name: "family_referral_date",
    value: product.family_referral_date,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: familyReferralStatus, //["התקבלה פניה. טרם התבצע בירור","ברור עם המשפחה","ברור עם גורם מפנה","קבלה לאינטייק","עברה לאינטייק",
            // "סיום. אין התאמה", "סיום. יש פוטנציאל", "סיום. המשפחה ויתרה"],
    name: "family_referral_status",
    value: product.family_referral_status,
    id: product.id,
    disable: "עברה לאינטייק",
    style: {width: "196px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_family_name",
    value: product.family_referral_family_name,
    id: product.id,
    style: {width: "120px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_woman_firstname",
    value: product.family_referral_woman_firstname,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_man_firstname",
    value: product.family_referral_man_firstname,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_team",
    value: product.family_referral_team,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_initiator",
    value: product.family_referral_initiator,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    newsection: "",
    type: "text",
    name: "family_referral_cell_woman",
    value: product.family_referral_cell_woman,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_cell_man",
    value: product.family_referral_cell_man,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "select",
    options: meritalStatus,
    name: "family_referral_merita_status",
    value: product.family_referral_merita_status,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "select",
    options: oneTill12plus, // ['0', '1','2', '3', '4', '5', '6','7','8','9','10','11','12+'],
    name: "family_referral_num_kids",
    value: product.family_referral_num_kids,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_age_woman",
    value: product.family_referral_age_woman,
    id: product.id,
    style: {width: "60px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_age_man",
    value: product.family_referral_age_man,
    id: product.id,
    style: {width: "60px"},
    edit: true
  },{
    newsection: "עבודה ורווחה",
    type: "text",
    name: "family_refferal_woman_workplace",
    value: product.family_refferal_woman_workplace,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_refferal_man_workplace",
    value: product.family_refferal_man_workplace,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_debts",
    value: product.family_referral_debts,
    id: product.id,
    style: {width: "100px"},
    edit: true
  },{
    type: "select",
    options: noYesWasInPastPlural, // [ 'כן', 'לא', 'היינו בעבר'],
    name: "family_referral_os_client",
    value: product.family_referral_os_client,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYesOther, // ["לא","כן","אחר"],
    name: "family_referral_prev_plan",
    value: product.family_referral_prev_plan,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_prev_plan_name",
    value: product.family_referral_prev_plan_name,
    id: product.id,
    style: {width: "300px"},
    edit: true
  },{
    newsection: "סיבה מרכזית לפניה",
    type: "select",
    options: noYes,
    name: "family_referral_r1",
    value: product.family_referral_r1,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYes,
    name: "family_referral_r2",
    value: product.family_referral_r2,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYes,
    name: "family_referral_r3",
    value: product.family_referral_r3,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYes,
    name: "family_referral_r4",
    value: product.family_referral_r4,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYes,
    name: "family_referral_r5",
    value: product.family_referral_r5,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: noYes,
    name: "family_referral_r6",
    value: product.family_referral_r6,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    newsection: "החלטות",
    type: "select",
    options: noYes,
    name: "family_referral_intake_set",
    value: product.family_referral_intake_set,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "text",
    name: "family_referral_intake_date",
    value: product.family_referral_intake_date,
    id: product.id,
    style: {width: "80px"},
    edit: true
  },{
    type: "select",
    options: ReferralMgrDecision, // ["המשך ברור","קבלה לאינטייק","דחיה","העברה לתכנית אחרת","אחר"],
    name: "family_referral_mgr_decision",
    value: product.family_referral_mgr_decision,
    id: product.id,
    style: {width: "120px"},
    edit: true
  },{
    type: "textarea",
    name: "family_referral_mgr_explain",
    value: product.family_referral_mgr_explain,
    id: product.id,
    style: {width: "200px"},
    edit: true
  },{
    type: "select",
    options: ReferralFamilyDecision, //["המשך לאינטייק", "ויתור", "המשך בירור", "אחר"],
    name: "family_referral_family_decision",
    value: product.family_referral_family_decision,
    id: product.id,
    style: {width: "120px"},
    edit: true
  },{
    type: "textarea",
    name: "family_referral_family_explain",
    value: product.family_referral_family_explain,
    id: product.id,
    style: {width: "200px"},
    edit: true
  }/*,{
    newsection: "",
    type: "text",
    name: "family_referral_code",
    value: product.family_referral_code,
    id: product.id,
    style: {width: "100px"},
    edit: false
  },{
    type: "text",
    name: "family_referral_family_code",
    value: product.family_referral_family_code,
    id: product.id,
    style: {width: "100px"},
    edit: false
  }*/] 
  export var emptyReferral =  {
    "family_referral_date": digmaDate(Date()),
    "family_referral_family_name": "",
    "family_referral_woman_firstname": "",
    "family_referral_man_firstname": "",
    "family_referral_code": "999999",
    "family_referral_family_code": "0",
    "family_referral_team": "מיטל",
    "family_referral_status": "", // "התקבלה פניה. טרם התבצע בירור",
    "family_referral_cell_woman": "",
    "family_referral_cell_man": "",
    "family_referral_initiator": "",
    "family_referral_age_woman": "",
    "family_referral_age_man": "",
    "family_referral_merita_status": "",
    "family_referral_num_kids": "",
    "family_refferal_woman_workplace": "",
    "family_refferal_man_workplace": "",
    "family_referral_debts": "",
    "family_referral_os_client": "",
    "family_referral_prev_plan": "",
    "family_referral_prev_plan_name": "",
    "family_referral_phone_call": "",
    "family_referral_intake_set": "" , // לא"לא",
    "family_referral_intake_date": "",
    "family_referral_r1": "", // לא
    "family_referral_r2": "", // לא
    "family_referral_r3": "", // לא
    "family_referral_r4": "", // לא
    "family_referral_r5": "", // לא
    "family_referral_r6": "", // לא
    "family_referral_mgr_decision": "", // לא"המשך ברור",
    "family_referral_family_decision": "", // לא"המשך ברור",
    "family_referral_mgr_explain": "",
    "family_referral_family_explain": ""
}
  export const ResetEmptyReferral = (e) => { 
    e["family_referral_date"] =  digmaDate(Date())
    e["family_referral_family_name"] =  ""
    e["family_referral_woman_firstname"] =  ""
    e["family_referral_man_firstname"] =  ""
    e["family_referral_code"] =  "999999"
    e["family_referral_family_code"] =  "0"
    e["family_referral_team"] =  "מיטל"
    e["family_referral_status"] =  "" //"התקבלה פניה. טרם התבצע בירור"
    e["family_referral_cell_woman"] =  ""
    e["family_referral_cell_man"] =  ""
    e["family_referral_initiator"] =  ""
    e["family_referral_age_woman"] =  ""
    e["family_referral_age_man"] =  ""
    e["family_referral_merita_status"] =  ""
    e["family_referral_num_kids"] =  ""
    e["family_refferal_woman_workplace"] =  ""
    e["family_refferal_man_workplace"] =  ""
    e["family_referral_debts"] =  ""
    e["family_referral_os_client"] =  ""
    e["family_referral_prev_plan"] =  ""
    e["family_referral_prev_plan_name"] =  ""
    e["family_referral_phone_call"] =  ""
    e["family_referral_intake_set"] =  "" // לא
    e["family_referral_intake_date"] =  ""
    e["family_referral_r1"] =  "" // לא
    e["family_referral_r2"] =  "" // לא
    e["family_referral_r3"] =  "" // לא
    e["family_referral_r4"] =  "" // לא
    e["family_referral_r5"] =  "" // לא
    e["family_referral_r6"] =  "" // לא
    e["family_referral_mgr_decision"] =  "" // לא"המשך ברור"
    e["family_referral_family_decision"] = "" // לא "המשך ברור"
    e["family_referral_mgr_explain"] =  ""
    e["family_referral_family_explain"] =  ""
}

/* Not in use
export const fieldType = (el, val, changef) => {
    // console.log("fType", el, val)
    if (el.type === "text" || el.type === "date" || el.type === "number" ){
        // console.log("text || date || number", el)

        if (el.editable)
            return (<input onChange={changef} type={el.type} name={el.accessor} placeholder={el.Header} value={val}  />)
        else return (<input type={el.type} name={el.accessor} placeholder={el.Header} value={val} disabled />)
    } 
    else if (el.type === "checkbox"){
      let v = 'values.'+ el.accessor;
      if (el.editable)
        return (<input onChange={changef} type={el.type} name={el.accessor} checked={v}  value={val} />)
      else return (<input onChange={changef} type={el.type} name={el.accessor} checked={v}  value={val} disabled />)
    } else if (el.type === "select"){
       // console.log("select in value", val)
        let options = []
        options = [...el.options].map(function (option) {
            //if ({val} === {option})
            //    return (<option key={option} value={option} selected >{option}</option>)
            //else 
            return (<option key={option} value={option}>{option}</option>)
        } )
        return (
            <select value={val} onChange={changef} name={el.accessor}>
                {options}
            </select>
        )
    } else if (el.type === "textarea") {
        // console.log("textarea", el)
        if (el.editable){
            return (<textarea onChange={changef} name={el.accessor} value={val} rows={3} cols={40} />)
        }
        return (<textarea onChange={changef} name={el.accessor} value={val} rows={3} cols={40} disabled />)
    } else return(<div>Unexpted</div>)
}
*/
/* Not in use
export class FieldCol extends Component {
    componentDidMount(){
        this.setState({...this.props.data})
    }
    render(){
        console.log("Ready to update edit", this.props.edit)
      var coolist = ReferralColDef.map((el) => 
          <div key={el.accessor}> 
            <label>{el.Header}</label> 
            {fieldType(el, this.props.data[el.accessor], this.props.edit)}
            {/*<Field type={el.type} name={el.accessor} placeholder={el.Header} />* /}
            {/*this.props.touch[el.accessor] && this.props.err[el.accessor] && <p>{this.props.err[el.accessor]}</p>* /}
          </div>
        )
  
      return(
        <div className="field-array">
          {coolist}
        </div>
      )
    }
  }
*/